export const ApplicationBuildVersion = '2020-05-26T07:54:54.853Z';